export class UnusedRelayResponseError extends Error {
	name = 'UnusedRelayResponseError';

	constructor(queryID: string) {
		super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
	}
}
